import PropTypes from 'prop-types'
import { memo, useMemo, useRef } from 'react'
import getUniqueIdString from 'lib/util/uniq'
import styles from './Logo.module.scss'
import useAnimationStacked from './hooks/useAnimationStacked'
import SVGStacked from './svg/SVGStacked'

/**
 * The `LogoStacked`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function LogoStacked (props) {
  const { className, isActive, style: inputStyle, ...attributes } = props
  const ref = useRef()
  const uid = useRef(getUniqueIdString('logo-'))
  const outputClassName = useMemo(
    () => [styles.logo, styles.logoStacked, className].join(' '),
    [className]
  )
  const style = useMemo(
    () => ({
      ...inputStyle,
      '--logo-gradient': `url(#${uid.current})`
    }),
    []
  )

  useAnimationStacked(ref, isActive)

  return (
    <SVGStacked
      ref={ref}
      className={outputClassName}
      style={style}
      uid={uid.current}
      {...attributes}
    />
  )
}

/** @type {object} */
LogoStacked.propTypes = {
  className: PropTypes.string,
  isActive: PropTypes.bool,
  style: PropTypes.shape()
}

/** @type {object} */
LogoStacked.defaultProps = {
  className: '',
  isActive: true,
  style: {}
}

// Memoize
export default memo(LogoStacked)
